import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-sentence-order',
  templateUrl: './sentence-order.component.html',
  styleUrls: ['./sentence-order.component.scss']
})
export class SentenceOrderComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
